import React from 'react';
import { Modal, Box, Paragraph, Motion, Stack, Text } from '@thecb/components';
import { useNavigate } from 'react-router-dom';

const IdleModal = ({
  modalOpen,
  toggleModal,
  timeLeftToLogout = 0,
  totalLogoutTime = 30,
  logout,
  cancelLogout,
}) => {
  const navigate = useNavigate();
  const percent =
    (totalLogoutTime - timeLeftToLogout) * (100 / totalLogoutTime);
  const transition = {
    ease: 'easeInOut',
    duration: totalLogoutTime,
  };
  const variants = {
    enter: {
      x: '-100%',
      backgroundColor: '#317D4F',
    },
    animate: {
      x: ['-100%', `${percent}%`],
      backgroundColor: ['#317D4F', '#93A441', '#F4CB32', '#E36E43', '#D11053'],
      times: [0, 0.4, 0.5, 0.6, 0.8],
      transition,
    },
  };

  const seconds = <Text weight="600">{`${timeLeftToLogout} seconds`}</Text>;

  const modalBody = (
    <Box padding="0">
      <Stack>
        <Paragraph>
          Are you still there? You will be logged out in {seconds} for your
          security.
        </Paragraph>
        <Motion>
          <Box
            padding="0"
            minHeight="10px"
            width="100%"
            borderRadius="6px"
            extraStyles="position: relative; overflow: hidden;"
          >
            <Motion
              padding="0"
              height="10px"
              width="100%"
              borderRadius="6px"
              extraStyles="position: relative;"
              variants={variants}
              initial="enter"
              animate={modalOpen ? 'animate' : 'enter'}
              exit="enter"
            />
          </Box>
        </Motion>
      </Stack>
    </Box>
  );
  const modalExtraProps = {
    ModalLink: () => <Box padding="0" />,
    modalHeaderText: 'Your session is about to expire!',
    modalBodyText: modalBody,
    continueButtonText: 'Stay Logged In',
    cancelButtonText: 'Log Out',
    continueAction: () => {
      cancelLogout();
      toggleModal(false);
    },
    cancelAction: () => {
      logout({ navigate });
      toggleModal(false);
    },
  };
  return (
    <Modal
      showModal={() => toggleModal(true)}
      hideModal={() => {
        cancelLogout();
        toggleModal(false);
      }}
      modalOpen={modalOpen}
      defaultWrapper={false}
      underlayClickExits={false}
      {...modalExtraProps}
    >
      <Box padding="0" />
    </Modal>
  );
};

export default IdleModal;
